import { TranslationKey } from "./types.ts";

export const groupTypes = (t: (key: TranslationKey) => string) => ({
  dynamic: () => t("common.groupTypes.dynamic"),
  local: () => t("common.groupTypes.local"),
  saml: () => t("common.groupTypes.saml"),
  other: () => t("common.groupTypes.samls"),
});
